import React from 'react';

import {Box, Paper, Skeleton, Stack} from 'views/components';

const FunnelBreakdownSkeleton = () => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {xs: '1fr', xl: 'repeat(2, minmax(0, 1fr))'},
        gap: 2,
      }}
    >
      <Paper
        sx={{
          p: 3,
          borderRadius: '12px',
          border: '1px solid #E5E5E5',
          boxShadow: 'none',
        }}
      >
        <Skeleton variant='text' width='34%' height={30} />
        <Skeleton variant='text' width='58%' height={22} sx={{mb: 3}} />
        <Stack spacing={2}>
          {
            Array.from({length: 7}).map((x, index) => {
              return (
                <Stack key={index} direction='row' alignItems='center' spacing={1.25}>
                  <Skeleton variant='text' width={110} height={18} />
                  <Skeleton variant='rounded' sx={{flex: 1}} height={8} />
                  <Skeleton variant='text' width={24} height={18} />
                </Stack>
              );
            })
          }
        </Stack>
      </Paper>
      <Paper
        sx={{
          p: 3,
          borderRadius: '12px',
          border: '1px solid #E5E5E5',
          boxShadow: 'none',
        }}
      >
        <Skeleton variant='text' width='30%' height={30} />
        <Skeleton variant='text' width='52%' height={22} sx={{mb: 2.5}} />
        <Stack spacing={1.5}>
          <Stack direction='row' alignItems='center' sx={{pb: 1, borderBottom: '1px solid #EAEAEA'}}>
            <Skeleton variant='text' sx={{flex: 1}} height={18} />
            <Skeleton variant='text' width={56} height={18} />
            <Skeleton variant='text' width={56} height={18} sx={{ml: 2}} />
            <Skeleton variant='text' width={56} height={18} sx={{ml: 2}} />
          </Stack>
          {
            Array.from({length: 9}).map((x, index) => {
              return (
                <Stack
                  key={index}
                  direction='row'
                  alignItems='center'
                  sx={{
                    py: 0.75,
                    px: 1,
                    borderRadius: '2px',
                    borderBottom: index === 8 ? 'none' : '1px solid #EAEAEA',
                  }}
                >
                  <Stack direction='row' alignItems='center' spacing={1} sx={{flex: 1, minWidth: 0}}>
                    <Skeleton variant='circular' width={8} height={8} />
                    <Skeleton variant='text' width='38%' height={18} />
                  </Stack>
                  <Skeleton variant='text' width={56} height={18} />
                  <Skeleton variant='text' width={56} height={18} sx={{ml: 2}} />
                  <Skeleton variant='text' width={56} height={18} sx={{ml: 2}} />
                </Stack>
              );
            })
          }
        </Stack>
      </Paper>
    </Box>
  );
};

export default React.memo(FunnelBreakdownSkeleton);
